import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';

export default function Scanner() {
  const navigate = useNavigate();

  const [value, setValue] = useState('');
  const debounceInput = useDebounce(value, 500);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    window.addEventListener('click', () => {
      inputRef.current?.focus();
    });
  }, []);

  useEffect(() => {
    if (debounceInput && debounceInput[0].length > 0) {
      const trimInput = debounceInput[0].replace(/\s+/g, '');
      navigate(`/gift-card/information/${trimInput}`);
    }
  }, [debounceInput]);

  return (
    <input
      ref={inputRef}
      id="scanner-input"
      type="text"
      className="absolute -right-20 bottom-0 size-0 opacity-0"
      placeholder="Enter code"
      autoFocus
      inputMode="none"
      onChange={(event) => setValue(event.currentTarget.value)}
    />
  );
}
